import { statusSubscriptionMapper, subscriptionMapper } from '../mappers/current-subscription-mapper';
import { errorMapper } from '../mappers/error-mapper';
import { subscriptionPlanMapper } from '../mappers/subscription-plan-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';

const subscriptionRepository = {
    async getPlans() {
        try {
            const plans = await apiClient.get({
                url: 'subscriptions/plans'
            });

            return plans.map(subscriptionPlanMapper.toDomain).filter(Boolean);
        } catch (error) {
            logError(error);

            return [];
        }
    },

    async getAll() {
        try {
            const subscriptions = await apiClient.get({
                url: 'subscriptions'
            });

            return subscriptions.map(subscriptionMapper.toDomain).filter(Boolean);
        } catch (error) {
            logError(error);

            return [];
        }
    },

    async create(body) {
        try {
            const plan = await apiClient.post({
                url: 'subscriptions/form',
                body
            });

            return plan;
        } catch (error) {
            throw errorMapper.toDomain(error);
        }
    },

    async cancel(subscriptionId) {
        try {
            await apiClient.post({
                url: `subscriptions/${subscriptionId}/cancel`
            });

            return true;
        } catch (error) {
            logError(error);

            throw error;
        }
    },

    async getStatus(subscriptionId) {
        try {
            const data = await apiClient.get({
                url: `subscriptions/${subscriptionId}/status`
            });

            return {
                paymentStatus: data.paymentStatus,
                status: data.status,
                plan: data.plan,
                id: data.id,
                upsells: data.upsells || [],
                features: data.features || [],
                derivedSubscriptions: data.derivedSubscriptions.map(statusSubscriptionMapper.toDomain),
                ...statusSubscriptionMapper.toDomain(data)
            };
        } catch (error) {
            logError(error);

            return {};
        }
    }
};

export {
    subscriptionRepository
};
